/*
* Thème: STACK
*/

import '@fancyapps/fancybox'

window.Lightbox_PluginInit = function () {
	$('.fancybox-link').fancybox({
		loop: true,
		buttons: ['close'],
		transitionEffect: 'slide',
		backFocus: false,
		caption: function (instance, current) {
			const $trigger = $(current.opts.$orig);
			var caption = ''
			if ($trigger.next('figcaption').length) {
				var caption = '<div class="builder-image-caption">' + $trigger.next('figcaption').html() + '</div>';
			}
			return caption
		},
	})

	$('.--fancybox-grid > .grid__item > div[class^="card-"]').each(function(index) {
		if ($(this).find('div[class*="__image"] a').length == 0) {
			if ($(this).find('div[class*="__image"]').length) {
				if ($(this).find('div[class*="__image"]').data('full-size') != '') {
					$(this).attr('href', $(this).find('div[class*="__image"]').data('full-size'))
					$(this).addClass('fancybox-grid-item')

					// Generate gallery name based on grid subtitle
					let $gridRow = $(this).closest('.grid-row');
					let galleryName = 'gallery'; // default

					// Look for subtitle
					let $subtitle = $gridRow.find('.grid-row__subtitle');
					if ($subtitle.length) {
						galleryName = $subtitle.text().trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
					}

					// Add data-fancybox attribute
					$(this).attr('data-fancybox', galleryName);
				}
			}
		}
	})

	// Group fancybox galleries by grid
	$('.--fancybox-grid a:not([class*="__cta"]), .fancybox-grid-item').fancybox({
	loop: true,
	buttons: ['quoteButton', 'close'],
	transitionEffect: 'slide',
	lang: document.body.lang || document.documentElement.lang,
	backFocus: false,
	infobar: false,
	btnTpl: {
		quoteButton: '<a href="' + (typeof xnumeric_l10n !== 'undefined' ? xnumeric_l10n.QUOTE_URL : '#') + '" class="btn-secondary fancybox-button--quote" title="' + (typeof xnumeric_l10n !== 'undefined' ? xnumeric_l10n.QUOTE_REQUEST : 'Demander un devis') + '">' +
			'<span>' + (typeof xnumeric_l10n !== 'undefined' ? xnumeric_l10n.QUOTE_REQUEST : 'Demander un devis') + '</span>' +
			'</a>'
	},
	caption: function(instance, current) {
		const $trigger = $(current.opts.$orig);
		var card_content = ''
		if ($trigger.closest('.grid__item').find('div[class*="__content"]').length) {
			card_content = $trigger.closest('.grid__item').find('div[class*="__content"]')[0].outerHTML;
		} else {
			if ($trigger.closest('.grid__item').find('[class*="__title"]').length) {
				card_content += $trigger.closest('.grid__item').find('[class*="__title"]')[0].outerHTML
			}
			if ($trigger.closest('.grid__item').find('[class*="__description"]').length) {
				card_content += $trigger.closest('.grid__item').find('[class*="__description"]')[0].outerHTML
			}
			if ($trigger.closest('.grid__item').find('[class*="__cta"]').length) {
				card_content += $trigger.closest('.grid__item').find('[class*="__cta"]')[0].outerHTML
			}
		}
		return '<div class="grid__item"><div class="card-">' + card_content + '</div></div>';
	},
})
}

/* End: STACK */
